function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.282 1.04102H6.31202C3.04708 1.04102 1 3.34833 1 6.61483V15.4265C1 18.693 3.03753 21.0003 6.31202 21.0003H15.681C18.9566 21.0003 20.9941 18.693 20.9941 15.4265V11.1574",
  stroke: "#C1CAE1",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.45286 9.6596L15.3874 1.73925C16.3759 0.753582 17.9781 0.753582 18.9666 1.73925L20.2588 3.0291C21.2473 4.01584 21.2473 5.61623 20.2588 6.6019L12.286 14.5604C11.8539 14.9918 11.2678 15.2345 10.6562 15.2345H6.67883L6.77864 11.2282C6.7935 10.6389 7.03452 10.0772 7.45286 9.6596Z",
  stroke: "#C1CAE1",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1818 2.96289L19.0298 7.80222",
  stroke: "#C1CAE1",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgEditSquare = function SvgEditSquare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditSquare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EditSquare.39874f83.svg";
export { ForwardRef as ReactComponent };